<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="id"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :show-borders="false"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Network Name" />
      <dx-column data-field="id" caption="Network ID" />
      <dx-column data-field="driver" caption="Driver" />
      <dx-column data-field="scope" caption="Scope" />
      <dx-column data-field="subnet" caption="Subnet" />
      <dx-column data-field="gateway" caption="Gateway" />
      <dx-column
        data-field="created"
        caption="Created"
        data-type="date"
        format="yyyy-MM-dd HH:mm:ss"
      />

      <dx-master-detail :enabled="true" template="detailTemplate" />

      <template #detailTemplate="{ data }">
        <dx-data-grid
          v-if="Array.isArray(data.data.containers)"
          :data-source="data.data.containers"
          :show-borders="true"
          :column-auto-width="true"
          :row-alternation-enabled="true"
          class="nested-grid"
        >
          <dx-column data-field="name" caption="Container Name" />
          <dx-column data-field="short_id" caption="Container ID" />
          <dx-column data-field="ipv4_address" caption="IPv4" />
          <dx-column data-field="mac_address" caption="MAC" />
          <dx-column data-field="endpoint_id" caption="Endpoint ID" />
        </dx-data-grid>
        <div v-else>
          <em>No containers connected.</em>
        </div>
      </template>
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxMasterDetail
} from 'devextreme-vue/data-grid';

import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';  

export default {
  name: 'DockerNetworksWithContainers',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxMasterDetail,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Docker Networks with Containers',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadNetworks();
  },
  methods: {
    async loadNetworks() {
      try {
        const response = await axios.get('/api/internal/docker/networks/with-containers');
        // const json = await res.json();
        this.dataSource = response.data;
      } catch (err) {
        console.error('Error loading networks with containers:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.nested-grid {
  margin: 10px 0;
  padding: 10px;
  border-top: 1px solid #ccc;
}
</style>
